import axios from 'axios';
import { ENVIRONMENTS } from '../constants/environments';

const DEFAULT_API_VERSION = 'v1';

export const api = axios.create({
  baseURL: `${ENVIRONMENTS.API_URL}/${DEFAULT_API_VERSION}`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});
